import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { Capacitor } from '@capacitor/core';
import { config } from '@/shared/config';

const app = initializeApp(config.firebase);

// App Check — blocks automated abuse (bot signups, SMS spam). Only active on production/staging web builds.
// Native apps use Play Integrity / DeviceCheck (configured in Firebase Console).
// Skipped in dev so the reCAPTCHA v3 token doesn't interfere with the reCAPTCHA v2 used by
// RecaptchaVerifier for phone auth — both can't share the same grecaptcha instance cleanly in dev.
if (!Capacitor.isNativePlatform() && !import.meta.env.DEV && config.recaptchaSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(config.recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

// On native Capacitor platforms, gapi iframes are blocked (capacitor://localhost origin).
// initializeAuth with indexedDB persistence bypasses the gapi iframe entirely.
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);

export const googleProvider = new GoogleAuthProvider();
